"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactZoomPanPinch = require("react-zoom-pan-pinch");
var _styles = require("@material-ui/core/styles");
var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));
var _getImageUrl = _interopRequireDefault(require("../../../../../Utils/getImageUrl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _closeButtonContainer, _closeButton;
  return {
    root: _defineProperty({
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }, theme.breakpoints.down('xs'), {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }),
    closeButtonContainer: (_closeButtonContainer = {
      justifyContent: 'flex-end',
      display: 'flex',
      position: 'fixed',
      right: '2rem',
      top: '2rem'
    }, _defineProperty(_closeButtonContainer, theme.breakpoints.down('xs'), {
      right: '1rem'
    }), _defineProperty(_closeButtonContainer, "zIndex", 1), _closeButtonContainer),
    closeButton: (_closeButton = {
      width: '3rem',
      height: '3rem'
    }, _defineProperty(_closeButton, theme.breakpoints.down('xs'), {
      width: '2rem',
      height: '2rem'
    }), _defineProperty(_closeButton, "display", 'flex'), _defineProperty(_closeButton, "alignItems", 'center'), _defineProperty(_closeButton, "justifyContent", 'center'), _defineProperty(_closeButton, "borderRadius", '50%'), _defineProperty(_closeButton, "border", 'none'), _defineProperty(_closeButton, "cursor", 'pointer'), _defineProperty(_closeButton, "color", theme.palette.primary.darkText), _closeButton)
  };
};
var ZoomImage = function ZoomImage(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    image = _ref.image,
    width = _ref.width,
    classes = _ref.classes,
    _ref$minScale = _ref.minScale,
    minScale = _ref$minScale === void 0 ? 1 : _ref$minScale,
    _ref$maxScale = _ref.maxScale,
    maxScale = _ref$maxScale === void 0 ? 4 : _ref$maxScale,
    _ref$alignmentAnimati = _ref.alignmentAnimationX,
    alignmentAnimationX = _ref$alignmentAnimati === void 0 ? -5 : _ref$alignmentAnimati,
    _ref$alignmentAnimati2 = _ref.alignmentAnimationY,
    alignmentAnimationY = _ref$alignmentAnimati2 === void 0 ? -5 : _ref$alignmentAnimati2,
    isLandscapeFormat = _ref.isLandscapeFormat,
    title = _ref.title;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageLoaded = _useState2[0],
    setImageLoaded = _useState2[1];
  var imgStyleLandscape = {
    height: 'auto',
    maxWidth: width
  };
  var imgStylePortrait = {
    maxHeight: window.innerHeight,
    width: 'auto'
  };
  var handleImageLoaded = function handleImageLoaded() {
    setImageLoaded(true);
  };
  var handleBackDropClick = function handleBackDropClick(event, reason) {
    if (reason === 'backdropClick') {
      onClose();
    }
  };
  if (show) {
    return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      className: classes.root,
      open: show,
      onClose: handleBackDropClick
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, imageLoaded && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.closeButtonContainer
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: classes.closeButton,
      onClick: onClose
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformWrapper, {
      initialScale: 1,
      limitToBounds: true,
      initialPositionX: 0,
      initialPositionY: 0,
      minScale: minScale,
      maxScale: maxScale,
      alignmentAnimation: {
        sizeX: alignmentAnimationX,
        sizeY: alignmentAnimationY,
        animationTime: 0,
        velocityAlignmentTime: 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformComponent, null, /*#__PURE__*/_react["default"].createElement("img", {
      onLoad: handleImageLoaded,
      src: (0, _getImageUrl["default"])(image),
      style: isLandscapeFormat ? imgStyleLandscape : imgStylePortrait,
      alt: title
    })))));
  }
  return null;
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'ZoomImage'
})(ZoomImage);